import { CalendarDays } from "lucide-react";
import { Link } from "react-router-dom";
import { dayMonth, daysUntil } from "../lib/api";
import { destinationImage } from "../lib/travel";
import type { Trip } from "../lib/types";

export function TripCard({ trip }: { trip: Trip }) {
  const countdown = daysUntil(trip.start_date);
  const hasDates = Boolean(trip.start_date && trip.end_date);
  const timing = trip.status === "completed" ? "Completed" : trip.status === "cancelled" ? "Cancelled" : countdown === null ? "Schedule later" : countdown === 0 ? "Underway" : `${countdown} days`;
  return <Link to={`/trips/${trip.id}/overview`} className="trip-card">
    <div className="trip-card-image" style={{ backgroundImage: `linear-gradient(180deg,transparent 35%,rgba(10,25,38,.82)),url("${destinationImage(trip)}")` }}>
      <div className="trip-card-top"><span className={`status-pill ${trip.status}`}>{trip.status}</span>{trip.hero_image_attribution && <span className="image-credit" title={`${trip.hero_image_attribution}${trip.hero_image_source_url ? ` · ${trip.hero_image_source_url}` : ""}`}>Photo source ⓘ</span>}</div>
      <div><p>{trip.destination}</p><h3>{trip.title}</h3></div>
    </div>
    <div className="trip-card-meta"><span><CalendarDays size={15} />{hasDates ? `${dayMonth(trip.start_date)} — ${dayMonth(trip.end_date)}` : `${trip.duration_days} days · Dates open`}</span><span>{timing}</span></div>
  </Link>;
}

export function TripSkeleton() {
  return <div className="trip-card skeleton"><div /><i /><i /></div>;
}
